import {BrowserModule} from '@angular/platform-browser';
import {DEFAULT_CURRENCY_CODE, NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, HttpBackend, HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {FormsModule} from '@angular/forms';
import {TableModule} from 'primeng/table';
import {
	ApiUrlInterceptor,
	Config,
	CountryService,
	EncodeUrlInterceptor,
	ErrorInterceptor,
	getDatepickerConfig,
	JWTInterceptor,
	LanguageService,
	SharedModule,
	TimeConfig
} from '@customcoding/shared';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BsDatepickerConfig, BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {DragulaModule} from 'ng2-dragula';
import {AccordionModule} from 'ngx-bootstrap/accordion';
import {environment} from '../environments/environment';
import menuConfig from './menu.json';
import settings from './settings.json';
import {CoreModule, CustomPreloadingStrategy, TEMPLATE_CONFIG} from '@customcoding/core';
import {ModalModule} from 'ngx-bootstrap/modal';
import {LightboxModule} from 'ngx-lightbox';
import {AppConfigService} from './goldenme/shared/services/app-config.service';
import {AngularSplitModule} from "angular-split";
//import {TauriService} from "./goldenme/shared/services/tauri.service";
//import {LoadingModalService} from "./goldenme/shared/services/loadingModal.service";
//import {PatientProfileDataService} from "./scap/patient/patient-profile/patient-profile-data.service";
import {DragDropModule} from "primeng/dragdrop";
import localeDe from '@angular/common/locales/de';
import {registerLocaleData} from "@angular/common";
import {MessageService} from "primeng/api";
import {NgScrollbarModule} from "ngx-scrollbar";
//import {SplashScreenComponent} from "./scap/shared/components/splash-screen/splash-screen.component";
//import {createErrorHandler as sentryCreateHandler} from '@sentry/angular-ivy';

/*
export function initializeApp(tauriService: TauriService) {
	return () => tauriService.isDesktopApp();
}
*/

@NgModule({
	declarations: [
		AppComponent,
		//SplashScreenComponent
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,
		FormsModule,
		AppRoutingModule,
		TableModule,
		ModalModule.forRoot(),
		BsDatepickerModule.forRoot(),
		BsDropdownModule.forRoot(),
		AccordionModule.forRoot(),
		DragulaModule.forRoot(),
		DragDropModule,
		LightboxModule,
		AngularSplitModule,
		NgScrollbarModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpBackend]
			},
			isolate: false
		}),

		CoreModule,
		SharedModule.forRoot(environment.apiUrl, menuConfig, settings)
	],
	exports: [
		TranslateModule
	],
	providers: [

		/*
		//TauriService,
		{
			provide: APP_INITIALIZER,
			useFactory: initializeApp,
			multi: true,
			deps: [], //TauriService
		},*/
		AppConfigService,
		{provide: Config, useExisting: AppConfigService},
		{provide: HTTP_INTERCEPTORS, useClass: JWTInterceptor, multi: true},
		{provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
		{provide: HTTP_INTERCEPTORS, useClass: ApiUrlInterceptor, multi: true},
		{provide: HTTP_INTERCEPTORS, useClass: EncodeUrlInterceptor, multi: true},
		{provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR'},
		{provide: BsDatepickerConfig, useFactory: getDatepickerConfig, deps: [TranslateService]},
		{provide: TimeConfig, useValue: {startHours: 7, endHours: 22, daysOfWeek: [1, 2, 3, 4, 5]}},
		//{provide: ErrorHandler, useValue: sentryCreateHandler()},
		{
			provide: TEMPLATE_CONFIG, useValue: {
				categories: [
					{
						name: {
							de: 'Allgemein',
							en: 'Miscellaneous'
						},
						variables: [
							{
								key: 'todayDate',
								translation: {
									de: 'Datum (heute)',
									en: 'Date (today)'
								}
							},
							{
								key: 'oTeamDate',
								translation: {
									de: 'O-Team Startdatum',
									en: 'O-Team start date'
								}
							}
						],
					},
					{
						name: {
							de: 'Koordinator',
							en: 'Coordinator'
						},
						variables: [
							{
								key: 'coordinatorFirstname',
								translation: {
									de: 'Vorname',
									en: 'Firstname'
								}
							},
							{
								key: 'coordinatorLastname',
								translation: {
									de: 'Nachname',
									en: 'Lastname'
								}
							},
							{
								key: 'coordinatorFullname',
								translation: {
									de: 'Ganzer Name',
									en: 'Full name'
								}
							},
							{
								key: 'coordinatorEmail',
								translation: {
									de: 'Email',
									en: 'Email'
								}
							},
							{
								key: 'coordinatorPhone',
								translation: {
									de: 'Telefonnummer',
									en: 'Phone number'
								}
							}
						]
					},
					{
						name: {
							de: 'Patient und Eltern',
							en: 'Patient and parents'
						},
						variables: [
							{
								key: 'created_at',
								translation: {
									de: 'Erstellungsdatum Patient',
									en: 'Patient creation date'
								}
							},
							{
								key: 'matricule',
								translation: {
									de: 'Matricule',
									en: 'Matricule'
								}
							},

							{
								key: 'patientFirstname',
								translation: {
									de: 'Patient Vorname',
									en: 'Patient firstname'
								}
							},
							{
								key: 'patientLastname',
								translation: {
									de: 'Patient Nachname',
									en: 'Patient lastname'
								}
							},
							{
								key: 'patientFullname',
								translation: {
									de: 'Patient ganzer Name',
									en: 'Patient full name'
								}
							},
							{
								key: 'bornDate',
								translation: {
									de: 'Patient Geburtsdatum',
									en: 'Patient date of birth'
								}
							},
							{
								key: 'caretakerFullname',
								translation: {
									de: 'Eltern ganzer Name',
									en: 'Parent full name'
								}
							},
							{
								key: 'caretakerSalutation',
								translation: {
									de: 'Eltern Anrede',
									en: 'Parent salutation'
								}
							},
							/* ...this is not implemented in the backend!
							{
								key: 'patientLivingAddressHeader',
								translation: {
									de: 'Adresse',
									en: 'Address'
								}
							},
							*/
							{
								key: 'livingAddressStreet',
								translation: {
									de: 'Meldeadresse Straße',
									en: 'Living-Address street'
								}
							},
							{
								key: 'livingAddressHouseNumber',
								translation: {
									de: 'MeldeAdresse Hausnummer',
									en: 'Living-Address house nr.'
								}
							},
							{
								key: 'livingAddressCity',
								translation: {
									de: 'Meldeadresse Stadt',
									en: 'Living-Address city'
								}
							},
							{
								key: 'livingAddressPostalCode',
								translation: {
									de: 'Meldeadresse Postleitzahl',
									en: 'Living-Address zip code'
								}
							},
							{
								key: 'livingAddressCountry',
								translation: {
									de: 'Meldeadresse Land',
									en: 'Living-Address country'
								}
							}
						]
					},
					{
						name: {
							de: 'Organisation / Firma',
							en: 'Organisation / Company',
						},
						variables: [
							{
								key: 'companyMainAddressHeader',
								translation: {
									de: 'Adresse',
									en: 'Address'
								}
							},
							{
								key: 'mainAddressStreet',
								translation: {
									de: 'Adresse Straße',
									en: 'Address street'
								}
							},
							{
								key: 'mainAddressCity',
								translation: {
									de: 'Adresse Stadt',
									en: 'Address city'
								}
							},
							{
								key: 'mainAddressHouseNumber',
								translation: {
									de: 'Adresse Hausnummer',
									en: 'Address house nr.'
								}
							},
							{
								key: 'mainAddressCountry',
								translation: {
									de: 'Adresse Land',
									en: 'Address country'
								}
							},
							{
								key: 'mainAddressPostalCode',
								translation: {
									de: 'Adresse Postleitzahl',
									en: 'Address zip code'
								}
							}
						]
					}
				]
			}
		},
		CustomPreloadingStrategy,
		//LoadingModalService,
		MessageService
	],
	bootstrap: [AppComponent]
})
export class AppModule {

	constructor(translate: TranslateService, languageService: LanguageService, countryService: CountryService) {

		registerLocaleData(localeDe);

		translate.setDefaultLang('de');

		languageService.register();
		countryService.setup();
	}

}

// Using HTTPBackend to ignore interceptors as language files are not part of the api url
// required for AOT compilation
export function HttpLoaderFactory(httpBackend: HttpBackend) {
	const http = new HttpClient(httpBackend);
	return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}
